import { FC } from 'react'

const App: FC = () => {
  return <div>App</div>
}

export default App
